import { compact, path } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { toTextFromProp } from '../../fields/text';

export const ctaLink = ({ primary }) =>
  compact({
    type: CommonSliceType.CTA_LINK,
    label: toTextFromProp('label', primary),
    url: path('link.url', primary),
  });
